export default "__VITE_ASSET__92d195c0__"